import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DeviceService } from './../../shared/services/device.service';
import { Device } from './product-detail.model';

@Component({
    selector: 'app-product-detail',
    templateUrl: './product-detail.component.html',
    styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent implements OnInit {
    deviceUrl: string;
    device: Device['data'];
    customOptions: any = {
        autoplay: true,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: false,
        fade: true,
        cssEase: 'linear',
        items: 1
    };

    relatedDevice: Related;
    constructor(private route: ActivatedRoute, private deviceService: DeviceService, private router: Router) {
        this.route.params.subscribe(Response => {
            this.deviceUrl = Response.url;
        });

        // reuse route
        this.router.routeReuseStrategy.shouldReuseRoute = function() {
            return false;
        };
    }

    ngOnInit() {
        this.getDetail();
    }

    back() {
        window.history.back();
    }
    getDetail() {
        this.deviceService.getDeviceDetail(this.deviceUrl).subscribe((res: Device['data']) => {
            this.device = res;
            // console.log(res);

            this.deviceService.getRelated(this.device.brand, this.device.deviceType).subscribe((relate: Related) => {
                this.relatedDevice = relate;
                // console.log(relate);
            });
            // console.log(this.device);
        });
    }
}

export class Related {
    data: {
        brand: string;
        deviceType: string;
        label: string;
        model: string;
        price: number;
        thumbnailUrl: string;
        _id: string;
        releaseDate: string;
        url: string;
    };
}
